import { AnalyticsBrowser } from '@segment/analytics-next';

export default AnalyticsBrowser.load({
    writeKey: import.meta.env.VITE_SEGMENT_KEY,
});
